import { UserRole } from "@/lib/api/user";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: () => <AuthLayout />,
  beforeLoad: ({ context }) => {
    if (
      context.stytchSession?.session_id &&
      context.stytchSession?.authentication_factors.length >= 2 &&
      context.user?.id &&
      context.user?.role !== UserRole.MENTEE
    ) {
      throw redirect({ to: "/" });
    }
  },
});

function AuthLayout() {
  return <Outlet />;
}
